import { flow, onSnapshot, types } from "mobx-state-tree";
import { queryMetadata } from "../../api/layers";
import { findIdFor } from "../../stores/helpers";

const Metadata = types.model({
  title: "",
  description: "",
  link: "",
  layerId: 0,
});

const MetadataStore = types
  .model({
    metadata: types.optional(types.array(Metadata), []),
    current: types.maybe(Metadata),
    loaded: false,
    loadedLayerIds: types.optional(types.array(types.integer), []),
    modalIsOpen: false,
  })
  .actions((self) => ({
    loadMetadata: flow(function* ({ layerId, url }) {
      self.current = undefined;
      const metadata = yield queryMetadata({ url, layerId });
      self.current = metadata;
    }),
    toggleModalIsOpen: () => {
      self.modalIsOpen = !self.modalIsOpen;
    },
    closeModal: () => {
      self.modalIsOpen = false;
    },
    openModal: () => {
      self.modalIsOpen = true;
    },
  }));

export const metadataStore = MetadataStore.create();

if  (process.env.NODE_ENV === "development") {
  onSnapshot(metadataStore, (newSnapshot) => {
    console.log("metadataStore snapshot: ", newSnapshot);
  });
}
